import { Box, Container, Fab, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import IconLibrary from '../IconLibrary';

function SJFloatingButtons({
  buttonsSchema,
  formRef,
  preSubmitActions = null,
}) {
  window.document.body.style['margin-bottom'] = '120px';
  return (
    <Box
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 50,
        zIndex: 2,
        pointerEvents: 'none',
      }}>
      <Container maxWidth="xl">
        <Stack
          direction="row"
          spacing={2}
          justifyContent="flex-end"
          sx={{ pointerEvents: 'auto' }}>
          {buttonsSchema.map(buttonSchema => {
            const Icon = IconLibrary[buttonSchema.icon];
            return (
              <Fab
                key={buttonSchema?.label?.id}
                variant="extended"
                size="medium"
                color="primary"
                onClick={() => {
                  if (preSubmitActions) {
                    preSubmitActions();
                  }
                  formRef.current.submit(buttonSchema);
                }}>
                <Icon sx={{ mr: 0.6, fontSize: '18px' }} />
                <FormattedMessage
                  id={buttonSchema.label.id}
                  defaultMessage={buttonSchema.label.defaultMessage}
                />
              </Fab>
            );
          })}
        </Stack>
      </Container>
    </Box>
  );
}

export default SJFloatingButtons;
